import { config } from '@rematter/config';
import { UserSortOption } from '@rematter/frontend-lib-api-client';
import { maybe } from '@rematter/ui-web';

import { userListQueryAtom } from '../_graphql/queryUserList';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $offset = atomFromQueryString.number('offset', 0);
export const $sortBy = atomFromQueryString.string<UserSortOption>(
  'sortBy',
  'FirstNameAsc',
);
export const $selectedOrganizationId = atomFromQueryString.string('org');
export const $status = atomFromQueryString.string<
  'all' | 'ACTIVE' | 'ARCHIVED'
>('status', 'all');

// 🟢🟢🟢 REMOTE DATA
export const $users = userListQueryAtom((get) => {
  const status = get($status);
  return {
    variables: {
      organizationId: get($selectedOrganizationId),
      searchTerm: get($searchTerm),
      status: status === 'all' ? null : status,
      sortBy: get($sortBy),
      pagination: maybe(get($limit), (limit) => ({
        limit,
        offset: get($offset) ?? 0,
      })),
    },
  };
});
